import { useState, useEffect } from "react"
// import NavBar from "@/component/navBar"
import $api from "@/api/index"
function Information() {
  const [hotspots, setHotspots] = useState([])

  const getHotSpots = async () => {
    const { result } = await $api.hotspot.list({
      position: "home",
      size: 10,
    })
    setHotspots(result || [])
  }

  useEffect(() => {
    getHotSpots()
  }, [])

  return (
    <div>
      {/* <NavBar hasSider={false} /> */}
      <h3 className="section__title">班型介绍</h3>
      <ul className="hot-list">
        {hotspots.map((item) => {
          return (
            <li key={item._id}>
              <a href=""> {item.name} </a>
              <div className="hot-content">
                <dl>
                  <dt>
                    <a href="https://bcsp.bdqn.cn" target="_blank" rel="noreferrer">
                      <img src={item.coverUrl} alt="" />
                    </a>
                  </dt>
                  <dd className="hot-content-tit">{item.name}</dd>
                  <dd className="hot-content-intro">{item.intro}</dd>
                  <dd>
                    <a className="hot-btn" href={item.jumpUrl} target="_blank" rel="noreferrer">
                      点击了解
                    </a>
                  </dd>
                </dl>
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default Information
